/* Product Updates panel. Override the custom properties to match your theme. */
.bay-pu {
  --bay-pu-bg: #ffffff;
  --bay-pu-ink: #1d1f2d;
  --bay-pu-ink-2: #1d1f2d;
  --bay-pu-muted: #5b616e;
  --bay-pu-line: #e2e2e2;
  --bay-pu-accent: #326cf8;
  --bay-pu-accent-ink: #1a3fa0;
  --bay-pu-off: #a9aeb8;
  --bay-pu-warn: #963511;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 100%;
  background: var(--bay-pu-bg);
  color: var(--bay-pu-ink);
  font: inherit;
}
.bay-pu *, .bay-pu *::before, .bay-pu *::after { box-sizing: border-box; }
.bay-pu-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 28px 40px 20px; flex-shrink: 0; }
.bay-pu-heading { margin: 0; font-size: 1.875rem; line-height: 1.3; font-weight: 650; }
.bay-pu-close {
  display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; margin-right: -10px;
  border: 0; border-radius: 8px; background: transparent; color: var(--bay-pu-ink-2); cursor: pointer;
}
.bay-pu-close:hover { background: #f3f4f6; }
.bay-pu-list { flex: 1; min-height: 0; overflow-y: auto; padding: 0 60px 0 28px; scrollbar-gutter: stable; }
.bay-pu-empty { margin: 24px 0; color: var(--bay-pu-muted); }
.bay-pu-item { display: flex; flex-direction: column; gap: 18px; padding: 32px 0 60px; border-bottom: 2px solid var(--bay-pu-line); }
.bay-pu-item:last-child { border-bottom: 0; }
.bay-pu-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; }
.bay-pu-title { margin: 0; font-size: 1.875rem; font-weight: 650; line-height: 1.35; overflow-wrap: anywhere; }
.bay-pu-desc { margin: 0; font-size: 1.875rem; line-height: 1.4; color: var(--bay-pu-ink-2); min-width: 0; overflow-wrap: anywhere; }
.bay-pu-badge { flex-shrink: 0; padding: 5px 12px; border-radius: 6px; font-size: 1.625rem; line-height: 1.4; font-weight: 600; white-space: nowrap; }
.bay-pu-badge[data-badge="devOnly"]   { background: #edeef1; color: #434955; }
.bay-pu-badge[data-badge="preview"]   { background: #e6f0fb; color: #1a4f8a; }
.bay-pu-badge[data-badge="beta"]      { background: #fdf1d6; color: #7a4b00; }
.bay-pu-badge[data-badge="new"]       { background: #e3f1ea; color: #1d5a3a; }
.bay-pu-badge[data-badge="endOfLife"] { background: #fce9de; color: #963511; }
.bay-pu-link { align-self: flex-start; font-size: 1.875rem; line-height: 1.4; font-weight: 650; color: var(--bay-pu-accent); text-decoration: none; padding: 12px 0 4px; }
.bay-pu-link:hover { color: var(--bay-pu-accent-ink); text-decoration: underline; }
.bay-pu-links { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 32px; }
.bay-pu-button { display: inline-block; margin-top: 12px; padding: 10px 24px; border-radius: 6px; background: var(--bay-pu-accent); color: #fff; font-size: 1.5rem; line-height: 1.4; font-weight: 650; text-decoration: none; }
.bay-pu-button:hover { background: var(--bay-pu-accent-ink); }
.bay-pu-error { margin: 0; font-size: 0.8125rem; color: var(--bay-pu-warn); }
.bay-pu-footer { flex-shrink: 0; padding: 26px 88px max(24px, env(safe-area-inset-bottom)); border-top: 2px solid var(--bay-pu-line); background: var(--bay-pu-bg); }
.bay-pu-suggest {
  width: 100%; min-height: 68px; padding: 10px 16px; border: 2px solid #8e9099; border-radius: 6px;
  background: var(--bay-pu-bg); color: #4b4d5a; font: inherit; font-size: 1.75rem; line-height: 1.25; font-weight: 650; cursor: pointer;
}
.bay-pu-suggest:hover { background: #f6f6f4; }

.bay-pu-switch {
  display: flex; align-items: center; justify-content: center; width: 70px; height: 44px; flex-shrink: 0;
  padding: 0; border: 0; background: transparent; cursor: pointer;
}
.bay-pu-switch:disabled { cursor: progress; }
.bay-pu-switch-track {
  position: relative; display: block; width: 64px; height: 36px; border-radius: 18px;
  background: var(--bay-pu-off, #a9aeb8); transition: background-color .15s;
}
.bay-pu-switch-track[data-on="true"] { background: var(--bay-pu-accent, #2457d6); }
.bay-pu-switch-knob {
  position: absolute; top: 5px; left: 5px; width: 26px; height: 26px; border-radius: 50%;
  background: #fff; box-shadow: 0 1px 2px rgba(0, 0, 0, .25); transition: left .15s;
}
.bay-pu-switch-track[data-on="true"] .bay-pu-switch-knob { left: 33px; }

@media (max-width: 480px) {
  .bay-pu-header { padding: 20px; }
  .bay-pu-heading { font-size: 1.375rem; }
  .bay-pu-list { padding: 0 20px; }
  .bay-pu-item { padding: 24px 0 32px; gap: 14px; }
  .bay-pu-row { gap: 12px; }
  .bay-pu-title, .bay-pu-desc, .bay-pu-link, .bay-pu-button { font-size: 1.125rem; }
  .bay-pu-badge { font-size: 1rem; padding: 4px 8px; }
  .bay-pu-footer { padding: 16px 20px max(16px, env(safe-area-inset-bottom)); }
  .bay-pu-suggest { min-height: 48px; font-size: 1rem; }
  .bay-pu-switch { width: 48px; }
  .bay-pu-switch-track { width: 44px; height: 26px; }
  .bay-pu-switch-knob { top: 3px; left: 3px; width: 20px; height: 20px; }
  .bay-pu-switch-track[data-on="true"] .bay-pu-switch-knob { left: 21px; }
}

.bay-pu :focus-visible { outline: 2px solid var(--bay-pu-accent); outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) {
  .bay-pu-switch-track, .bay-pu-switch-knob { transition: none; }
}
